import React, { useEffect, useState } from 'react';
// import avatarUrl from '../../assets/images/portrait/small/avatar-s-11.jpg';
import avatarUrl from '../../assets/images/placeholder.jpg';
import { useDispatch, useSelector } from 'react-redux';
import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import { Col, Form, Label, Row, Input, FormFeedback, Button, InputGroup, InputGroupText } from 'reactstrap';
import { Controller, useForm } from 'react-hook-form';
import { ButtonText, CommonHeadFooter, NewsLetterStyle, UserPicUpdate } from '../../StyledComponents';
import { genderOptions, getImageURL, myToast, toFormatDateWOTime } from '../../snippets/snippets';
import ManageServices from '../../utility/api/services/ManageServices';
import PopupModal from '../Manage/PopupModal';
import { getProfileData } from '../../utility/api/services/UserPortal/UserSlice';
import Select from 'react-select';
import { Calendar } from 'react-feather';
import Flatpickr from "react-flatpickr"
import "@styles/react/libs/flatpickr/flatpickr.scss"


const UserMyProfile = (props) => {

  const { isLoading, userProfile, error } = useSelector((state) => state.userPortal);

  const dataAvaliable = userProfile !== undefined

  const [userData, setUserData] = useState({});

  const [modal, setModal] = useState(false);
  const handleModal = () => setModal(!modal);



  const dispatch = useDispatch();

  const userAvatar = userProfile?.data?.image;


  const [picture, setPicture] = useState('')
  const [img, setImg] = useState('')
  const [selectedName, setSelectedName] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [date, setDate] = useState('')

  const handleDate = (selectedDates) => {
    const date = selectedDates[0];
    setDate(date);
    handleInputChange({ target: { name: 'dob', value: date } });
  };


  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setUserData((prevData) => ({
      ...prevData,
      [name]: value
    }));
  };

  const handleSelectChange = (selectedOption) => {
    setUserData((prevData) => ({
      ...prevData,
      gender: selectedOption ? selectedOption.value : ''
    }));
  };


  const [loading, setLoading] = useState(true);



  // console.log('userData::  ', userData, dataAvaliable)

  // useEffect(()=> {
  //   dispatch(getDashboardData());
  // }, [dispatch]);

  // if (isLoading) {
  //   return <div>Loading...</div>;
  // }

  // if (error) {
  //   return <div>Error: {error}</div>;
  // }

  const getData = () => {
    dispatch(getProfileData());
    setLoading(false)
  }


  useEffect(() => {
    setLoading(true)
    if (Object.keys(userProfile).length === 0) {
      getData()
    }
  }, [])

  useEffect(() => {

    if (Object.keys(userProfile).length !== 0) {

      setUserData({
        firstName: userProfile.data.firstName || '',
        lastName: userProfile.data.lastName || '',
        phoneNo: userProfile.data.phone || '',
        gender: userProfile.data.gender || '',
        dob: userProfile?.data?.dob || '',
        email: userProfile.data.email || ''
      });


      if (userProfile?.data?.dob) {
        setDate(userProfile.data.dob); // Assuming dob is in 'YYYY-MM-DD' format
      }


      setLoading(false)
    }
  }, [userProfile])



  const SignupSchema = yup.object().shape({
    // firstName: yup.string().min(3, 'First Name must be at least 3 characters').max(30, 'First Name must be at most 30 characters').required(),
    // lastName: yup.string().min(3, 'Last Name must be at least 3 characters').max(30, 'Last Name must be at most 30 characters').required(),
    // email: yup.string().email('Invalid email').required('Please enter your email'),
    // phoneNo: yup.string().matches(/^\d{10}$/, 'Phone number must be 10 digits').required('Enter Phone Number'),
    // dob: yup.date().required('Please enter your date of birth'),
    // gender: yup.string().required('Please select your gender'),
  });

  const {
    control,
    handleSubmit,
    formState: { errors },
  } = useForm({ mode: 'onChange', resolver: yupResolver(SignupSchema) });


  const handleImageChange = (e) => {


    const selectedImage = e.target.files[0];

    if (selectedImage) {

      setPicture(selectedImage);
      setSelectedName(selectedImage.name);
      
      try {
        const imgURL = URL.createObjectURL(selectedImage);
        // setPicture(selectedImage)
        setImg(imgURL);
      } catch (error) {
        console.error('Error creating object URL:', error);
      }
    }

  }

  const handleTimeoutAlert = (obj) => {

    const myPromise = new Promise(async (resolve, reject) => {
      console.log('obj', obj);

      let formData = new FormData();
      formData.append('firstName', obj.firstName)
      formData.append('lastName', obj.lastName)
      formData.append('dob', obj.dob)
      formData.append('gender', obj.gender)
      formData.append('image', obj.image)
      formData.append('phone', obj.phone)


      

      ManageServices.postUserProfile(formData)
        .then((response) => {
          const result = response.data
          console.log('RESULT', response)

          if (response.data.statusCode == 200) {
            setIsDisabledData(true)
            dispatch(getProfileData());
          }
          resolve(result)
        }).catch((err) => {
          reject(err)
        })


    })
    console.log('myToastUpdate', myPromise)
    return myToast(myPromise)
  }


  const onSubmit = (data) => {
    console.log("on submit: ", data);
    
    const obj = {
      firstName: data.firstName || userProfile.data.firstName,
      lastName: data.lastName || userProfile.data.lastName,
      gender: data.gender?.value || userProfile.data.gender,
      phone: data.phoneNo || userProfile.data.phone,
      dob: data.dob || userProfile.data.dob
    }

    console.log('OBJ', obj)

    if (errorMessage == "" && obj.firstName != '' && obj.lastName != '' && obj.gender != '' && obj.dob != '') {



      const formData = {
        ...obj,
        ...(picture && { image: picture }),
      };

      // if (dataAvaliable) {
      //   const updatedObj = Object.assign(formData, { id: formData1.id });
      //   setUpdatedData(updatedObj);
      // }

      handleTimeoutAlert(formData)

    }
  }

  const [isDisabledData, setIsDisabledData] = useState(true)

  const [openName, setOpenName] = useState('')

  const clickHandler = (name) => {
    setModal(true)
    setOpenName(name)

  }

  useEffect(() => {
    if (userAvatar) {
      setPicture(userAvatar);
    }
  }, [userAvatar]);


  return (
    <>
      <div className='p-3 container-fluid'>
        <NewsLetterStyle style={{ fontWeight: '700' }}>My Profile</NewsLetterStyle>

        <div style={{ display: 'flex', justifyContent: 'center' }}>
          <Row style={{ flexDirection: 'row', flexWrap: 'wrap', border: '1px solid #D9D9D9', borderRadius: '20px', margin: '0.5rem', height: '100%', maxWidth: '752px', width: '100%', padding: '1rem' }}>
            <Col xl='3' lg='3' md='3'>
            <div className='text-center'>
              <img
                src={picture !== null ? picture : img}
                height={"137"}
                width={"137"}
                style={{ borderRadius: '50%' }}
              />
              </div>
            </Col>
            <Col xl='9' lg='9' md='9' style={{ display: 'flex', flexDirection: 'row', flexWrap: 'wrap', justifyContent: 'space-between', alignItems: 'center' }}>
              <div style={{ display: 'flex', flexDirection: 'row', flexWrap: 'wrap', justifyContent: 'space-between', width: '100%' }}>
                <div>
                  <NewsLetterStyle style={{ fontWeight: '600' }}>Upload a new photo</NewsLetterStyle>
                  <CommonHeadFooter style={{ fontWeight: '400' }}>{selectedName || "Click to upload"}</CommonHeadFooter>
                </div>
                {
                  !isDisabledData &&
                  <UserPicUpdate>
                    <CommonHeadFooter htmlFor='pic'>UPDATE</CommonHeadFooter>
                    <Input type='file' id='pic'
                      onChange={handleImageChange}
                      placeholder='Select Picture'
                      className="inputfile"
                      accept="image/png, image/gif, image/jpeg, image/jpg"
                    // hidden
                    />
                  </UserPicUpdate>
                }
              </div>
            </Col>
          </Row>
        </div>

        <Form onSubmit={handleSubmit(onSubmit)}>
          <Row>
            <Col className='mb-1' lg='4' md='4' sm="12" xl="4">
              <Label className='form-label' for='firstName'>First Name *</Label>
              <Controller
                id='firstName'
                name='firstName'
                control={control}
                render={({ field }) => (
                  <Input {...field} type='text'
                    value={dataAvaliable ? userData?.firstName : ""}
                    invalid={errors.firstName && true} placeholder='Enter First Name' disabled={isDisabledData}
                    onChange={(e) => {
                      field.onChange(e); // Call the default onChange from React Hook Form
                      handleInputChange(e); // Update the userData state
                    }}
                  />
                )}
              />
              {errors.firstName && <FormFeedback>{errors.firstName.message}</FormFeedback>}
            </Col>
            <Col className='mb-1' lg='4' md='4' sm="12" xl="4">
              <Label className='form-label' for='lastName'>Last Name *</Label>
              <Controller
                id='lastName'
                name='lastName'
                control={control}
                render={({ field }) => (
                  <Input {...field} type='text'
                    value={dataAvaliable ? userData?.lastName : ""}
                    invalid={errors.lastName && true} placeholder='Enter Last Name' disabled={isDisabledData}
                    onChange={(e) => {
                      field.onChange(e); // Call the default onChange from React Hook Form
                      handleInputChange(e); // Update the userData state
                    }}
                  />
                )}
              />
              {errors.lastName && <FormFeedback>{errors.lastName.message}</FormFeedback>}
            </Col>
            <Col className='mb-1' lg='4' md='4' sm="12" xl="4">
              <Label className='form-label' for='email'>Email</Label>
              <Controller
                id='email'
                name='email'
                disabled={true}
                control={control}
                render={({ field }) => (
                  <Input {...field} type='email'
                    value={dataAvaliable ? userData?.email : ""}
                    invalid={errors.email && true} placeholder='Enter Email' />
                )}
              />
              {/* {errors.email && <FormFeedback>{errors.email.message}</FormFeedback>} */}
            </Col>
            <Col className='mb-1' lg='4' md='4' sm="12" xl="4">
              <Label className='form-label' for='phoneNo'>Phone Number *</Label>
              <Controller
                id='phoneNo'
                name='phoneNo'
                control={control}
                render={({ field }) => (
                  <Input {...field} type='number'
                    value={dataAvaliable ? userData?.phoneNo : ""}
                    invalid={errors.phoneNo && true} placeholder='Enter Phone Number' disabled={isDisabledData}
                    onChange={(e) => {
                      field.onChange(e); // Call the default onChange from React Hook Form
                      handleInputChange(e); // Update the userData state
                    }}
                  />
                )}
              />
              {errors.phoneNo && <FormFeedback>{errors.phoneNo.message}</FormFeedback>}
            </Col>
            <Col className='mb-1' lg='4' md='4' sm="12" xl="4">
        <Label className='form-label' for='dob'>Date of Birth</Label>
        <InputGroup>
          <InputGroupText>
            <Calendar size={15} />
          </InputGroupText>
          <Controller
            name="dob"
            control={control}
            defaultValue={userData?.dob || ''}
            render={({ field }) => (
              <Flatpickr
                className='form-control'
                id='dob'
                options={{
                  dateFormat: 'Y-m-d',
                  defaultDate: userData?.dob || '',
                }}
                value={date}
                disabled={isDisabledData}
                onChange={(date) => {
                  field.onChange(date);
                  handleDate(date);
                }}
              />
            )}
          />
        </InputGroup>
        {errors.dob && <FormFeedback>{errors.dob.message}</FormFeedback>}
      </Col>


            <Col className='mb-1' lg='4' md='4' sm="12" xl="4">
              <Label className='form-label' for='gender'>Gender *</Label>
              <Controller
                id='gender'
                name='gender'
                control={control}

                render={({ field }) => (
                  <Select
                    {...field}
                    isDisabled={isDisabledData}
                    options={genderOptions}
                    isClearable
                    value={dataAvaliable ? genderOptions.find(x => x.value == userData?.gender) : ''}
                    styles={{
                      control: (provided) => ({
                        ...provided,
                        borderColor: errors.gender ? 'red' : provided.borderColor,
                      }),
                    }}
                    onChange={(selectedOption) => {
                      field.onChange(selectedOption); // Call the default onChange from React Hook Form
                      handleSelectChange(selectedOption); // Update the userData state
                    }}
                  />
                )}
              />
              {errors.gender && <FormFeedback>{errors.gender.message}</FormFeedback>}
            </Col>
          </Row>
          <div className='my-3 d-flex justify-content-end gap-2'>

            {!isDisabledData ? (
              <>
                <button type='submit' className='btn' style={{ backgroundColor: '#FBBD34', color: 'white' }}>Save Changes</button>
                <button type='button' className='btn' style={{ backgroundColor: '#D9534F', color: 'white' }} onClick={() => setIsDisabledData(true)}>Cancel</button>
              </>
            ) : (
              <>
                <button type='button' className='btn' style={{ backgroundColor: '#41B8E4', color: 'white' }} onClick={() => clickHandler("User Password")}>Change Password</button>
                <button type='button' className='btn' onClick={() => setIsDisabledData(false)} style={{ backgroundColor: '#41B8E4', color: 'white' }}>Edit Profile</button>
              </>
            )}
          </div>
        </Form>
      </div>

      <PopupModal
        company_id={''}
        open={modal}
        setModal={setModal}
        handleModal={handleModal}
        name={openName}
        tableData={''}
        setTableData={''}
      />
    </>
  );
};

export default UserMyProfile;


